import {VisitAPIDataSourceCore} from './VisitAPIDataSourceCore';
import {VisitAPIDataSourceManagement} from './VisitAPIDataSourceManagement';
import {VisitAPIDataSourceStore} from './VisitAPIDataSourceStore';

/**
 * Unified Visit API Data Source
 * Combines all visit-related API operations following clean architecture principles
 */
export const VisitAPIDataSource = {
  // Core operations (Overview, List, Details, Analytics, Reports)
  ...VisitAPIDataSourceCore,

  // Management operations (CRUD, Approve/Reject, Edit, Delete)
  ...VisitAPIDataSourceManagement,

  // Store-specific operations (History, Active visits, Bulk operations)
  ...VisitAPIDataSourceStore
};
